import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { UserSubscriptionRetrieveInterface } from "../../../middleware/interfaces/user/user-subscription-retrieve-interface";

export const UserSubscriptionRetrieve = {
  Retrieve: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const userSubscriptionRetrieveData: UserSubscriptionRetrieveInterface =
        state.data;
      const url = "./php/user/user-subscription-retriever-proxy.php";
      await axios
        .post(url, userSubscriptionRetrieveData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = "SOMETHING WENT WRONG! PLEASE CONTACT ADMIN.";
    }

    return serverResponse;
  },
};
